"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logEntryRowSchema = void 0;
const zod_1 = require("zod");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const enum_names_js_1 = require("./enum-names.js");
const severitySchema = sigma_engine_shared_1.RequirementsV2.RequirementSeveritySchema;
const workflowStateSchema = sigma_engine_shared_1.RequirementsV2.RequirementWorkflowStateSchema;
exports.logEntryRowSchema = zod_1.z.object({
    id: zod_1.z.string(),
    buildId: zod_1.z.string(),
    build: zod_1.z.object({ displayName: zod_1.z.string().nullable() }),
    entryType: sigma_engine_shared_1.RequirementsV2.LogEntryTypeSchema,
    authorUserId: zod_1.z.string().nullable(),
    authorRole: sigma_engine_shared_1.RequirementsV2.LogEntryAuthorRoleSchema,
    severity: severitySchema.nullable(),
    severityName: enum_names_js_1.requirementSeverityNameSchema
        .nullable()
        .describe('Name of the numeric `severity`, e.g. `Warning`; null when `severity` is null.'),
    workflowState: workflowStateSchema.nullable(),
    workflowStateName: enum_names_js_1.requirementWorkflowStateNameSchema
        .nullable()
        .describe('Name of the numeric `workflowState`, e.g. `Unreviewed`; null when `workflowState` is null.'),
    message: zod_1.z.string().nullable(),
    description: zod_1.z.string().nullable(),
    hiddenAt: zod_1.z.date().nullable(),
    hiddenByUserId: zod_1.z.string().nullable(),
    createdAt: zod_1.z.date(),
    sourceSystem: zod_1.z.string().nullable(),
    sourceRunId: zod_1.z.string().nullable(),
    sourceResultKey: zod_1.z.string().nullable(),
    deterministicValidationPayload: zod_1.z.unknown().nullable().optional(),
    aiValidationPayload: zod_1.z.unknown().nullable().optional(),
    notePayload: sigma_engine_shared_1.RequirementsV2.noteLogPayloadSchema.nullable(),
    updatePayload: sigma_engine_shared_1.RequirementsV2.UpdateLogPayloadSchema.nullable(),
    continuityPayload: sigma_engine_shared_1.RequirementsV2.continuityLogPayloadSchema.nullable(),
    assertionResultIds: zod_1.z.string().array(),
});
//# sourceMappingURL=log-entry-row.dto.js.map